import { render, staticRenderFns } from "./SampleSetTest.vue?vue&type=template&id=fce55774&scoped=true&"
import script from "./SampleSetTest.vue?vue&type=script&lang=js&"
export * from "./SampleSetTest.vue?vue&type=script&lang=js&"
import style0 from "./SampleSetTest.vue?vue&type=style&index=0&id=fce55774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce55774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
